<!-- 商品管理 V2 - 已勾选商品列表弹框 -->
<template>
  <el-dialog
    :title="$t('message.productV2SelectedList')"
    :visible.sync="visible"
    width="720px"
    append-to-body
    custom-class="selected-list-dialog"
  >
    <div v-if="!list.length" class="empty-tip">{{ $t('message.productV2NoSelected') }}</div>
    <div v-else class="selected-table">
      <div class="selected-head">
        <span>{{ $t('message.managementDesignation') }}</span>
        <span>{{ $t('message.userInfo') }}</span>
        <span>{{ $t('message.productV2ProductInfo') }}</span>
        <span>{{ $t('message.operation') }}</span>
      </div>
      <div v-for="item in list" :key="item.sys_code" class="selected-row">
        <span>{{ item.client_sku_code }}</span>
        <span>
          <p>ID:{{ item.user && item.user.id }}</p>
          <p>{{ item.user && item.user.realname }}</p>
        </span>
        <span class="product-cell">
          <el-image
            v-if="item.pic"
            class="thumb"
            :src="item.pic"
            fit="cover"
            :preview-src-list="[item.pic]"
          />
          <span v-else>-</span>
        </span>
        <span>
          <el-button type="text" class="remove-btn" @click="remove(item)">{{ $t('message.delete') }}</el-button>
        </span>
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="visible = false">{{ $t('message.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
/**
 * 跨页勾选结果弹框：展示 selectedList，支持单项移除
 */
export default {
  name: 'SelectedListDialog',
  props: {
    list: { type: Array, default: () => [] }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    // 从已选列表移除，由父组件同步当前页勾选状态
    remove(item) {
      this.$emit('remove', item.sys_code)
    }
  }
}
</script>

<style lang="scss">
.selected-list-dialog {
  .el-dialog__body {
    max-height: 520px;
    overflow: auto;
    padding: 12px 24px 8px;
  }

  .empty-tip {
    padding: 40px 0;
    color: #999;
    text-align: center;
  }

  .selected-head,
  .selected-row {
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr 80px;
    gap: 12px;
    align-items: center;
    min-height: 48px;
    padding: 8px 12px;
  }

  .selected-head {
    background: #edeff4;
    font-weight: 700;
  }

  .selected-row {
    border-bottom: 1px solid #ebeef5;

    p {
      margin: 0;
      line-height: 20px;
    }
  }

  .product-cell {
    display: flex;
    align-items: center;
  }

  .thumb {
    width: 48px;
    height: 48px;
    border-radius: 4px;
  }

  .remove-btn {
    color: #b4272d;
  }
}
</style>
